import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

const emptyRole = {
  title: "",
  defaultJD: "",
  techStackOptions: ""
};

const RoleManager = () => {
  const [roles, setRoles] = useState([]);
  const [form, setForm] = useState(emptyRole);

  const load = async () => {
    try {
      const res = await api.get("/api/roles");
      setRoles(res.data || []);
    } catch (err) {
      console.error("Failed to load roles:", err.response?.data);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleSubmit = async () => {
    if (!form.title || !form.defaultJD) {
      alert("Title and JD required");
      return;
    }

    const trimmedName = form.title.trim();

    try {
      await api.post("/api/roles", {
        name: trimmedName,
        defaultJD: form.defaultJD,
        techStackOptions: form.techStackOptions
          .split(",")
          .map(s => s.trim())
          .filter(s => s.length > 0)
      });

      alert("Role Created Successfully!");
      setForm(emptyRole);
      load(); // refresh list
    } catch (err) {
      console.error("Error creating role:", err.response?.data);
      alert(err.response?.data?.message || "Failed to create role");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl mb-4">Manage Roles</h2>

      {/* Roles List */}
      <div className="mb-6 p-4 bg-gray-100 rounded">
        <h3 className="font-semibold mb-2">Current Roles in Database:</h3>
        <div className="space-y-1">
          {roles.length === 0 ? (
            <p className="text-gray-500">No roles found</p>
          ) : (
            roles.map((role, index) => (
              <div
                key={role._id}
                className="text-sm p-2 bg-white rounded border"
              >
                <strong>{index + 1}.</strong> {role.name}
                <span className="ml-2 text-gray-500">
                  (JD: {role.defaultJD || "None"})
                </span>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Form */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <input
            placeholder="Title"
            value={form.title}
            onChange={e => setForm({ ...form, title: e.target.value })}
            className="border p-2 mb-2 w-full"
          />

          <textarea
            placeholder="Default JD"
            value={form.defaultJD}
            onChange={e => setForm({ ...form, defaultJD: e.target.value })}
            className="border p-2 mb-2 w-full"
          />

          <input
            placeholder="Tech Stack (comma separated)"
            value={form.techStackOptions}
            onChange={e =>
              setForm({ ...form, techStackOptions: e.target.value })
            }
            className="border p-2 mb-2 w-full"
          />
        </div>

        <div>
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded w-full"
          >
            Create Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleManager;